module.exports = __webpack_public_path__ + "static/media/post.581a66fc.svg";